import { Component } from 'react'
import { OverlayContainer } from 'components/features/pfm/Overlay/OverlayContainer'
import * as styles from 'components/features/pfm/LightboxImage/LightboxImage.styl'
import CloseButton from 'components/atoms/buttons/CloseButton'
import AdjustableImage, { AdjustableImageProps } from 'components/features/pfm/AdjustableImage/AdjustableImage'


type LightboxImageProps = AdjustableImageProps

type LightboxImageState = {
  isOpen: boolean
}

export default class LightboxImage extends Component<LightboxImageProps, LightboxImageState> {
  state: LightboxImageState = {
    isOpen: false,
  }

  render () {
    const {
      ...imageProps
    } = this.props
    const { isOpen } = this.state

    return (
      <div className={ styles.container }>
        <AdjustableImage
          { ...imageProps }
          onClick={ this.handleImageClick }
        />
        { isOpen && this.renderLightbox() }
      </div>
    )
  }

  private renderLightbox () {
    const { image } = this.props

    return (
      <OverlayContainer onClose={ this.handleClose }>
        <div className={ styles.lightboxImage } onClick={ this.handleImageClick }>
          <AdjustableImage image={ image } preventLazyRender />
        </div>
        <div className={ styles.closeButton }>
          <CloseButton
            theme='light'
            onClick={ this.handleClose }
          />
        </div>
      </OverlayContainer>
    )
  }

  private handleImageClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  private handleClose = () => {
    this.setState({
      isOpen: false,
    })
  }
}
